// src/TermsOfService.js
import React, { useEffect } from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  useTheme,
  useMediaQuery
} from "@mui/material";
import AppShell from "./AppShell";
import usePageTitle from "../hooks/usePageTitle";

const TermsOfService = () => {
  usePageTitle("Terms of Service");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <AppShell>
      <Container maxWidth="md">
      <Box sx={{ p: isMobile ? 0 : 1 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 3,
        }}
      >
        <Typography
          variant="h4"
          sx={{
            mb: 2,
            fontWeight: "bold",
            color: "primary.main",
          }}
        >
          Terms of Service
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          {/* Replace the following with your actual TOS copy */}
          Welcome to The Collector Stop! By using our website and services, you agree to the following terms and conditions.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: "bold" }}>
          1. Acceptable Use
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          You agree not to misuse the service or interfere with its normal operation.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: "bold" }}>
          2. Intellectual Property
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          All content on this site is owned by The Collector Stop or its licensors.
        </Typography>

        {/* Add as many sections as you need */}
      </Paper>
      </Box>
      </Container>
    </AppShell>
  );
};

export default TermsOfService;
